// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-tags-input[data-v-f929eb9a] {\n  max-width: 100% !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
